import React from 'react';

const IconExpand = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12C21 11.4477 21.4477 11 22 11H28C28.5523 11 29 11.4477 29 12V18C29 18.5523 28.5523 19 28 19C27.4477 19 27 18.5523 27 18V14.4142L22.7071 18.7071C22.3166 19.0976 21.6834 19.0976 21.2929 18.7071C20.9024 18.3166 20.9024 17.6834 21.2929 17.2929L25.5858 13H22C21.4477 13 21 12.5523 21 12Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C12.5523 21 13 21.4477 13 22V25.5858L17.2929 21.2929C17.6834 20.9024 18.3166 20.9024 18.7071 21.2929C19.0976 21.6834 19.0976 22.3166 18.7071 22.7071L14.4142 27H18C18.5523 27 19 27.4477 19 28C19 28.5523 18.5523 29 18 29H12C11.4477 29 11 28.5523 11 28V22C11 21.4477 11.4477 21 12 21Z"
      fill="#06090D"
    />
  </svg>
);

export default IconExpand;
